<template>
  <nav class="flex items-center space-x-1">
    <a
      v-for="item in navItems"
      :key="item.href"
      :href="item.href"
      :class="[
        'px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200',
        isActive(item.href)
          ? 'text-green-600 bg-green-50'
          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
      ]"
      @click="handleClick(item.href, $event)"
    >
      {{ item.label }}
    </a>
  </nav>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue'
import { useTextos } from '../../i18n/idioma'
import { useRouter } from 'vue-router'

const props = defineProps<{
  currentPath: string
}>()

const router = useRouter()

const isActive = (href: string) => {
  return href === props.currentPath && !href.startsWith('#')
}

const handleClick = (href: string, event: Event) => {
  event.preventDefault()
  if (href.startsWith('#')) {
    if (props.currentPath !== '/') {
      router.push('/')
      setTimeout(() => {
        const element = document.querySelector(href)
        if (element) element.scrollIntoView({ behavior: 'smooth' })
      }, 100)
    } else {
      const element = document.querySelector(href)
      if (element) element.scrollIntoView({ behavior: 'smooth' })
    }
  } else {
    router.push(href).then(() => {
      window.scrollTo(0, 0)
    })
  }
}

const textos = {
  pt: { beneficios: 'Benefícios', agentes: 'Agentes', planos: 'Planos', whitelabel: 'Whitelabel' },
  en: { beneficios: 'Benefits', agentes: 'Agents', planos: 'Plans', whitelabel: 'White Label' },
  es: { beneficios: 'Beneficios', agentes: 'Agentes', planos: 'Planes', whitelabel: 'White Label' },
}
const tx = useTextos(textos)

const navItems = computed(() => [
  { href: '#benefits', label: tx.value.beneficios },
  { href: '#agents', label: tx.value.agentes },
  { href: '#pricing', label: tx.value.planos },
  { href: '/whitelabel', label: tx.value.whitelabel },
  { href: '/a2', label: 'A2' }
])
</script>
